/**
 *    @author:
 *    @since:
 *
 */

import { Component, OnInit, ViewEncapsulation, ViewChild, HostListener} from '@angular/core';
import { Router } from '@angular/router'; 
import { TimerService } from 'src/refresh/service/timer-service';
import { FormBaseComponent } from '../_common/component/form-base.component';
import { CCB, InputData } from '../_common/data/input-data';
import { GAData, Path, Progress } from  "../_common/constant/page-const";
import { CCBMainValidation } from './CCB_main.validator';
import { ViewportScroller } from '@angular/common';
import { LightBox } from 'src/refresh/layout/light-box/light-box.component';
import { ProgressService } from 'src/refresh/service/progress-service';
import { Confirm } from 'src/refresh/service/constant';
import { CommonService } from 'src/refresh/service/common-service';

@Component({ 
      selector: 'CCB_main',
      templateUrl: './CCB_main.component.html',
      styleUrls: ['./CCB_main.component.less'],
      //encapsulation: ViewEncapsulation.None
})
export class CCBMainComponent extends FormBaseComponent implements OnInit {

       public childNameParam:Object;
       public CCB:CCB;
       public error_PrimEmpty:string = '';
       public error_SSN:string = '';
       public error_Notice:string = '';
       CCBMainValidation:CCBMainValidation;
       @ViewChild(LightBox) box1: LightBox;
       isOpened:boolean = false;

       constructor( protected router: Router ,
                    public timerService:TimerService,
                    public viewportScroller: ViewportScroller,
                    protected progress:ProgressService,
                    public data:InputData,
                    private commonService: CommonService ) {

                    super(router,timerService);  

                    this.CCBMainValidation = new CCBMainValidation(this,Progress.CCB);
                    super.setValidator(this.CCBMainValidation);
 
                    this.CCB = this.data.CCB;
 
                    if ( this.data.aboutChild.isChildDeceased == Confirm.YES || 
                         this.data.eligibility.isCustodyOtherThanParent == Confirm.YES )                          
                         super.setNextPage(Path.OrderSummary,Path.Transition2);      
                    else
                         super.setNextPage(Path.SINMain,Path.Transition2);      
 
                    if ( this.data.CCB.isFromAreYourSure == true ) {
                         this.data.CCB.isFromAreYourSure = false;
                         super.forward();
                         return;
                    }                    
 
 
                    ///if ( this.progress.progressStatus[Progress.CCB] == 4 ) this.progress.progressStatus[Progress.CCB] = 1;
                    
                    this.childNameParam = { childName: this.data.aboutChild.name.getFullName()}; 
                    
                   if( this.data.certifyingParents.size === 1 ) {
                       this.CCB.primaryCaregiver  = this.data.certifyingParents.keys().next().value;    
                   }      
                   
                   this.commonService.getCloseLightBox().subscribe((r) =>{
                        if(this.isOpened) this.notAgreeClose();
                   });
 
                   InputData.currentPageIdx = 20;
                   if ( InputData.moveNext == 0 || InputData.moveNext == InputData.currentPageIdx ) this.timerService.isForwarding = false;
       }

       public ngOnInit() {

       	  super.forwardNext(this.data.eligibility.listedParentCount);
      }
       
       public onNextClick() : boolean {

              if ( super.onNextClick() ) {
                   this.CCB.careGiver = this.data.parents[this.CCB.primaryCaregiver].name.getFullName();
                   super.gtag(GAData.Button,GAData.continue_product);
              }
              return true;
      }
      
      public showNotice(event) {
            if(this.CCB.primaryCaregiver == -1){
                  event.preventDefault();
                  this.CCBMainValidation.setPCError();
                  var el = document.getElementById("primaryCaregiver").offsetTop;
                  window.scrollTo(0, el);
                  let ctrl = document.getElementById('radio_primaryCaregiverRadio_0');
                  ctrl.focus();
            } else{
                  event.preventDefault();
                  this.box1.open(); 
                  this.isOpened = true; 
            }
                
      }
      
      public agreeClose() {
            this.error_Notice = '';
            this.CCB.chk_consent = true;
            this.box1.close();
            this.isOpened = false;
      }
      
      public notAgreeClose() {
            this.CCB.chk_consent = false;
            this.box1.close();
            this.isOpened = false;
      }

      public keyPress(event:any) {
            if ( event.keyCode == 13 ) {
                  this.notAgreeClose();
          }
      }

      @HostListener('document:keydown.escape', ['$event'])
      public escape(){
            if(this.isOpened) {
                  this.notAgreeClose();
            }
     }

      public dontApply() {
            //this.data.CCB.primaryCaregiver = -1;
            //this.data.CCB.chk_consent = false;
       
            this.timerService.reset();
            this.router.navigate([Path.CCBAreYouSure]);

            this.progress.progressStatus[Progress.CCB] = 4;

            super.gtag(GAData.Button,GAData.no_BC);
      }
}
